export default "__VITE_ASSET__DEmTPFqs__"